import { Link, useLocation, useNavigate } from "react-router-dom";

export default function SmartLink({ href = "/", children, onNavigate, ...rest }) {
  const location = useLocation();
  const navigate = useNavigate();

  if (/^(https?:|mailto:|tel:)/.test(href)) {
    return <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" {...rest}>{children}</a>;
  }
  if (href.includes("#")) {
    const [path, hash] = href.split("#");
    const go = (e) => {
      e.preventDefault();
      onNavigate?.();
      const scroll = () => document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
      if ((path || "/") === location.pathname) scroll();
      else { navigate(path || "/"); setTimeout(scroll, 350); }
    };
    return <a href={href} onClick={go} {...rest}>{children}</a>;
  }
  return <Link to={href} onClick={onNavigate} {...rest}>{children}</Link>;
}
